module.exports = "/_next/static/images/DefineDetectValidate@2x-de0bd047e47be92b4bf3523bbeab954e.png";